function WeatherIcon({ type, size = 48 }) {
  switch (type) {
    case 'sunny':
      return (
        <svg width={size} height={size} viewBox="0 0 64 64" className="weather-svg">
          <defs>
            <radialGradient id="sunGlow">
              <stop offset="30%" stopColor="#fbbf24" />
              <stop offset="100%" stopColor="#fbbf24" stopOpacity="0" />
            </radialGradient>
          </defs>
          <circle cx="32" cy="32" r="24" fill="url(#sunGlow)" className="sun-glow" />
          <circle cx="32" cy="32" r="14" fill="#fbbf24" />
          <circle cx="32" cy="32" r="10" fill="#fcd34d" />
          <circle cx="28" cy="28" r="4" fill="#fef3c7" opacity="0.5" />
        </svg>
      );

    case 'partly-cloudy':
      return (
        <svg width={size} height={size} viewBox="0 0 64 64" className="weather-svg">
          <defs>
            <radialGradient id="sunGlowSmall">
              <stop offset="30%" stopColor="#fbbf24" />
              <stop offset="100%" stopColor="#fbbf24" stopOpacity="0" />
            </radialGradient>
          </defs>
          <circle cx="20" cy="20" r="16" fill="url(#sunGlowSmall)" className="sun-glow" />
          <circle cx="20" cy="20" r="9" fill="#fbbf24" />
          <circle cx="20" cy="20" r="6" fill="#fcd34d" />
          <ellipse cx="36" cy="42" rx="20" ry="11" fill="#64748b" className="cloud cloud-drift" />
          <circle cx="26" cy="36" r="10" fill="#94a3b8" className="cloud cloud-drift" />
          <circle cx="40" cy="34" r="9" fill="#94a3b8" className="cloud cloud-drift" />
          <circle cx="33" cy="32" r="7" fill="#cbd5e1" className="cloud cloud-drift" />
        </svg>
      );

    case 'cloudy':
      return (
        <svg width={size} height={size} viewBox="0 0 64 64" className="weather-svg">
          <ellipse cx="28" cy="42" rx="22" ry="12" fill="#64748b" className="cloud cloud-drift" />
          <circle cx="18" cy="34" r="12" fill="#94a3b8" className="cloud cloud-drift" />
          <circle cx="36" cy="30" r="11" fill="#94a3b8" className="cloud cloud-drift-slow" />
          <circle cx="28" cy="28" r="9" fill="#cbd5e1" className="cloud cloud-drift-slow" />
          <circle cx="42" cy="36" r="8" fill="#cbd5e1" className="cloud cloud-drift" />
        </svg>
      );

    case 'foggy':
      return (
        <svg width={size} height={size} viewBox="0 0 64 64" className="weather-svg">
          {[20, 28, 36, 44, 52].map((y, i) => (
            <rect
              key={y}
              x={8 + (i % 2) * 6}
              y={y}
              width={48 - (i % 2) * 12}
              height="3"
              rx="1.5"
              fill="#94a3b8"
              opacity={0.25 + i * 0.12}
              className={`fog-line fog-line-${i % 4}`}
            />
          ))}
        </svg>
      );

    case 'rainy':
      return (
        <svg width={size} height={size} viewBox="0 0 64 64" className="weather-svg">
          <ellipse cx="32" cy="22" rx="20" ry="11" fill="#475569" />
          <circle cx="20" cy="16" r="11" fill="#64748b" />
          <circle cx="38" cy="14" r="10" fill="#64748b" />
          <circle cx="30" cy="12" r="7" fill="#94a3b8" />
          {[{x: 18, d: 0}, {x: 26, d: 0.4}, {x: 34, d: 0.8}, {x: 42, d: 0.2}, {x: 22, d: 0.6}].map((drop, i) => (
            <ellipse
              key={i}
              cx={drop.x} cy={38 + i * 2}
              rx="1.5" ry="3"
              fill="#60a5fa"
              className={`raindrop-v2`}
              style={{ animationDelay: `${drop.d}s` }}
            />
          ))}
        </svg>
      );

    case 'snowy':
      return (
        <svg width={size} height={size} viewBox="0 0 64 64" className="weather-svg">
          <ellipse cx="32" cy="20" rx="20" ry="11" fill="#64748b" />
          <circle cx="20" cy="14" r="11" fill="#94a3b8" />
          <circle cx="38" cy="12" r="10" fill="#94a3b8" />
          <circle cx="30" cy="10" r="7" fill="#cbd5e1" />
          {[{x: 18, y: 36}, {x: 30, y: 40}, {x: 42, y: 34}, {x: 24, y: 48}, {x: 36, y: 50}, {x: 20, y: 54}].map((p, i) => (
            <circle
              key={i}
              cx={p.x} cy={p.y}
              r="2.5"
              fill="#e2e8f0"
              className={`snowdot snowdot-${i % 3}`}
            />
          ))}
        </svg>
      );

    case 'stormy':
      return (
        <svg width={size} height={size} viewBox="0 0 64 64" className="weather-svg">
          <ellipse cx="32" cy="18" rx="22" ry="12" fill="#334155" />
          <circle cx="18" cy="12" r="12" fill="#475569" />
          <circle cx="40" cy="10" r="11" fill="#475569" />
          <circle cx="30" cy="8" r="8" fill="#64748b" />
          <polygon
            points="32,26 27,40 33,36 28,54 42,34 34,38 38,26"
            fill="#fbbf24"
            className="lightning"
          />
          {[{x: 18, d: 0.2}, {x: 44, d: 0.7}].map((drop, i) => (
            <ellipse
              key={i}
              cx={drop.x} cy={40}
              rx="1.5" ry="3"
              fill="#60a5fa"
              className="raindrop-v2"
              style={{ animationDelay: `${drop.d}s` }}
            />
          ))}
        </svg>
      );

    default:
      return (
        <svg width={size} height={size} viewBox="0 0 64 64" className="weather-svg">
          <ellipse cx="32" cy="38" rx="22" ry="12" fill="#64748b" />
          <circle cx="22" cy="30" r="11" fill="#94a3b8" />
          <circle cx="38" cy="28" r="10" fill="#cbd5e1" />
        </svg>
      );
  }
}

export default WeatherIcon;
